function ShowMoreButton({ onclick }) {
  return (
    <div className="cm1_btn_a" onClick={() => onclick()}>
      Show More
    </div>
  );
}

export { ShowMoreButton };
